import React, { useEffect, useRef, useState } from 'react';
import './Stats.css';

const stats = [
  { value: 5000, suffix: '+', label: 'Students Placed' },
  { value: 10, suffix: '+', label: 'Countries' },
  { value: 98, suffix: '%', label: 'Visa Success Rate' },
  { value: 12, suffix: '+', label: 'Years Experience' },
];

function CountUp({ target, suffix, start }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    let current = 0;
    const step = target / 60;
    const timer = setInterval(() => {
      current += step;
      if (current >= target) { setCount(target); clearInterval(timer); }
      else setCount(Math.floor(current));
    }, 25);
    return () => clearInterval(timer);
  }, [start, target]);
  return <>{count.toLocaleString()}{suffix}</>;
}

export default function Stats() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="stats-section" ref={ref}>
      <div className="stats-inner">
        {stats.map((s, i) => (
          <div className="stat-card" key={i} style={{ animationDelay: `${i * 0.1}s` }}>
            <div className="stat-number">
              <CountUp target={s.value} suffix={s.suffix} start={visible} />
            </div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
